import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';
import { IndicatorCodes } from 'src/app/core/_enums/indicators.code';
import { SationImpactColor } from 'src/app/core/_enums/station.impact.color';
import { Impact } from 'src/app/core/_models/impact';
import { Indicator } from 'src/app/core/_models/indicator';
import { PdfPictures } from 'src/app/core/_models/pdfPictures';
import { ProjectEcoPro } from 'src/app/core/_models/projectEcoPro';
import { HIGHCHARTS_EXPORTING, HIGHCHARTS_TRANSLATIONS } from 'src/constants/graph.constants';
import { SvgToPngService } from '../../../core/_utils/svgToPng.service';

HC_more(Highcharts);
HC_exporting(Highcharts);
HC_offlineExporting(Highcharts);

let componentContext: any;

@Component({
  selector: 'app-bar-indicators-detailed-bySolutions',
  templateUrl: './bar-indicators-detailed-bySolutions.component.html',
  styleUrls: ['./bar-indicators-detailed-bySolutions.component.scss']
})
export class BarIndicatorsDetailedBySolutionsComponent implements OnChanges, OnInit {
  @Input() projectData: ProjectEcoPro = {};
  @Input() indicators: Indicator[] = [];
  @Input() isEcoPro: boolean = true;
  @Input() isSynthetiqueResult: boolean = true;
  @Input() synthese: any;

  chart: any;

  indicatorComparatif: Indicator = {
    isChecked: false
  };

  private defaultApplied = false;
  updateFlag: boolean = false;
  totalsRef: number[] = [];

  // Highcharts config

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: 'Comparaison par module et scénario'
    },
    lang: HIGHCHARTS_TRANSLATIONS,
    colors: ['#7cb5ec', '#434348', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'],
    exporting: HIGHCHARTS_EXPORTING,
    xAxis: {
      crosshair: true
    },
    yAxis: {
      /*min: 0,*/
      title: {
        text: componentContext?.labelI18n.indicatorLabel(componentContext?.indicatorComparatif)
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    plotOptions: {
      series: {
        dataLabels: [
          {
            enabled: true,
            useHTML: true,
            y: -25,
            crop: false,
            overflow: 'allow',
            formatter: function () {
              if (this.colorIndex == 0) {
                componentContext.totalsRef.splice(this.point.index, 0, this.y);
                return '<span style="background-color: lightgray; font-size: 10px; padding: 2px; border:1px solid"> Ref. </span>';
              } else {
                if (this.y && this.y != 0) {
                  const percentageDiff = (100 * (this.y - componentContext.totalsRef[this.point.index])) / componentContext.totalsRef[this.point.index];
                  if (!isNaN(percentageDiff)) {
                    const displayValue = percentageDiff == 0 ? '&nbsp' + '-' + '&nbsp' : percentageDiff > 0 ? '+' + Math.round(percentageDiff) + '%' : Math.round(percentageDiff) + '%';
                    const backgroundColor = percentageDiff < 0 ? '#25e043' : percentageDiff > 0 ? '#ff4c4c' : 'lightgray';

                    return '<span style="background-color:' + backgroundColor + '; font-size: 10px; padding: 2px; border:1px solid">' + displayValue + '</span>';
                  } else {
                    return '';
                  }
                } else {
                  return '';
                }
              }
            }
          },
          {
            enabled: true,
            allowOverlap: true,
            format: '{point.y}',
            crop: false,
            overflow: 'allow'
          }
        ]
      },
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    }
  };

  constructor(public labelI18n: LabelI18nService) {
    componentContext = this;
  }

  ngOnChanges() {
    if (!this.defaultApplied && this.indicators.length > 0 && this.synthese?.length > 0) {
      this.defaultApplied = true;
      const coIndicator = this.indicators.find((i: Indicator) => i.code === IndicatorCodes.CO2);
      if (coIndicator) {
        coIndicator.isChecked = true;
        this.indicatorComparatif = coIndicator;
      }
    }
    if (this.indicatorComparatif) this.formatDataForGraph();
  }

  ngOnInit() {
    if (this.isEcoPro /*|| this.isSynthetiqueResult*/) {
      this.indicators = this.indicators.filter((indicator) => indicator.code == IndicatorCodes.CO2 || indicator.code == IndicatorCodes.Energie);
    }
  }

  onChangeIndicatorSelect(cb: MatCheckboxChange, indicator: Indicator) {
    this.indicators.forEach((i) => (i.isChecked = false));
    if (cb.checked) {
      indicator.isChecked = true;
      this.indicatorComparatif = indicator;
      this.formatDataForGraph();
    } else {
      this.indicatorComparatif = { isChecked: false };
    }
  }

  async generateCharts(indicators: Indicator[]) {
    let pdfCharts: PdfPictures = {
      coCharts: [],
      energyCharts: [],
      gncharts: [],
      tkCharts: [],
      synthetiqueResultENcharts: [],
      synthetiqueResultCOcharts: []
    };

    var options = Highcharts.merge(Highcharts.getOptions().exporting, { type: 'application/pdf' });

    for (let indicator of indicators) {
      this.indicatorComparatif = indicator;
      this.formatDataForGraph();
      switch (indicator.code) {
        case 'EN':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.synthetiqueResultENcharts?.push(base64);
          break;
        case 'CO':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.synthetiqueResultCOcharts?.push(base64);
          break;
        default:
          break;
      }
    }
    return pdfCharts;
  }

  generateArray(obj: any) {
    return Object.keys(obj).map((key) => {
      return { key: key, value: obj[key] };
    });
  }

  formatDataForGraph() {
    let series: {
      type: string;
      name: string | undefined;
      color?: string;
      data: number[];
    }[] = [];
    const stationImpactsNames: string[] = [];
    let stationsImpacts: Impact[] = [];
    const stationsImpactsForSelectedIndicator: Impact[] = [];
    let colorToDisplay: SationImpactColor;

    if (this.indicatorComparatif.code && this.synthese && this.synthese.length > 0) {
      if (this.indicatorComparatif.code == 'EN') colorToDisplay = SationImpactColor.TotalCostEN;
      else colorToDisplay = SationImpactColor.TotalCostCO;
      let specificSynthese = this.synthese.find((row: any) => row.code === this.indicatorComparatif.code);

      specificSynthese.solutions.forEach((solution: any) => {
        let stationImpact: Impact = {};
        let headers = this.generateArray(solution.rows[0].values);

        headers.forEach((header: any) => {
          stationImpact = {};
          switch (header.key) {
            case SationImpactColor.TotalCost.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = colorToDisplay.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = 'Total';
              break;
            default:
              break;
          }
          if (Object.keys(stationImpact).length !== 0) {
            stationsImpactsForSelectedIndicator.push(stationImpact);
          }
          if (stationImpact.displayName && !stationImpactsNames.includes(stationImpact.displayName)) {
            stationImpactsNames.push(stationImpact.displayName);
          }
        });
      });

      specificSynthese.solutions.forEach((solution: any) => {
        stationImpactsNames.forEach((stationImpactName) => {
          let stationImpactRef = stationsImpacts.find((stationImpact) => stationImpact.displayName == stationImpactName);

          if (
            stationsImpactsForSelectedIndicator.find(
              (stationImpactSelected) =>
                stationImpactSelected.displayName == stationImpactName && stationImpactSelected.solutionId == solution.solutionId && stationImpactSelected.scenarioSolutionAssociationId == solution.scenarioSolutionAssociationId
            ) == null
          ) {
            if (stationImpactRef == null) {
              stationsImpacts.push({
                displayName: stationImpactName,
                dataForGraph: [0]
              });
            } else {
              stationImpactRef.dataForGraph?.push(0);
            }
          } else {
            const stationsImpactsForStation = stationsImpactsForSelectedIndicator.filter(
              (stationImpact) => stationImpact.displayName == stationImpactName && stationImpact.solutionId == solution.solutionId && stationImpact.scenarioSolutionAssociationId == solution.scenarioSolutionAssociationId
            );

            let ceuValueForStationType = 0;

            stationsImpactsForStation.forEach((stationImpact) => {
              if (stationImpact && stationImpact.value) {
                ceuValueForStationType += stationImpact.value;
              }
            });

            if (stationImpactRef == null) {
              let stationImpactColor = stationsImpactsForSelectedIndicator.find((stationImpact) => stationImpact.displayName == stationImpactName)?.color;
              stationsImpacts.push({
                displayName: stationImpactName,
                color: stationImpactColor,
                dataForGraph: [Number(ceuValueForStationType.toFixed(2))]
              });
            } else {
              stationImpactRef.dataForGraph?.push(Number(ceuValueForStationType.toFixed(2)));
            }
          }
        });
      });
      stationsImpacts.forEach((stationImpact) => {
        if (stationImpact.dataForGraph) {
          series.push({
            type: 'column',
            name: stationImpact.displayName,
            data: stationImpact.dataForGraph,
            color: stationImpact.color
          });
        }
      });

      this.chartOptions.xAxis = {
        categories: specificSynthese.solutions.map((solution: any) => solution.displayName!),
        labels: { style: { fontWeight: 'bold', fontSize: '13px' } }
      };

      this.chartOptions.yAxis = {
        /*min: 0,*/
        title: {
          text: componentContext?.labelI18n.indicatorLabelWithUnit(componentContext?.indicatorComparatif)
        },
        stackLabels: {
          enabled: true,
          useHTML: true,
          y: -10,
          style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color:
              // theme
              (Highcharts.defaultOptions.title!.style && Highcharts.defaultOptions.title!.style.color) || 'black'
          },
          formatter: function () {
            if (this.x == 0) {
              componentContext.totalRef = this.total;
              return '';
            } else {
              if (componentContext.totalRef) {
                const percentageDiff = (100 * (this.total - componentContext.totalRef)) / componentContext.totalRef;
                if (!isNaN(percentageDiff) && this.total != 0) {
                  const displayValue = percentageDiff == 0 ? '&nbsp' + '-' + '&nbsp' : percentageDiff > 0 ? '+' + Math.round(percentageDiff) + '%' : Math.round(percentageDiff) + '%';
                  const backgroundColor = percentageDiff < 0 ? '#25e043' : percentageDiff > 0 ? '#ff4c4c' : 'lightgray';

                  return '<span style="background-color:' + backgroundColor + '; font-size: 13px; padding: 3px; border:1px solid">' + displayValue + '</span>';
                } else {
                  return '';
                }
              } else {
                return '';
              }
            }
          }
        }
      };
      this.chartOptions.series = series as Highcharts.SeriesOptionsType[];
      //this.chartOptions.title = this.chartTitle;
      if (this.indicatorComparatif.code == 'EN')
        this.chartOptions.title = {
          text: 'Consommation énergétique totale (MJ)'
        };
      else
        this.chartOptions.title = {
          text: 'Emission totale de GES (t CO2eq)'
        };

      this.updateFlag = true;
      this.chart = Highcharts.chart('hidden-container', this.chartOptions);
    }
  }
}
